var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUvSensor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2181_33206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 24.2188C20.9868 24.2188 24.2188 20.9868 24.2188 17C24.2188 13.0132 20.9868 9.78125 17 9.78125C13.0132 9.78125 9.78125 13.0132 9.78125 17C9.78125 20.9868 13.0132 24.2188 17 24.2188Z",
    stroke: "black",
    strokeWidth: 1.28906,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5.80234V1.53125M17 32.4688V28.1977M24.9234 9.07656L27.9313 6.06875M6.06875 27.9313L9.08516 24.9148M9.08516 9.06797L6.07734 6.06016M27.9484 27.9313L24.932 24.9148M5.80234 17H1.53125M32.4688 17H28.1977",
    stroke: "black",
    strokeWidth: 1.28906,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2181_33206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.2266,
    height: 32.2266,
    fill: "white",
    transform: "translate(0.886719 0.886719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUvSensor);
export default __webpack_public_path__ + "static/media/uv-sensor.2f6b50bd756a9813e72bc85471a0cffb.svg";
export { ForwardRef as ReactComponent };